import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useAuthenticatedAccount } from 'src/features/auth/context'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { useAcceptWorksheet } from '../../api/acceptWorksheet'
import { useWorksheetValueContext } from '../../context/WorksheetValue'
import { WorksheetDetail, WorksheetStatus } from '../../types'
import { canPerformWorksheetAction } from '../../utils/permissions'

type Props = {
  worksheet: WorksheetDetail
  mutateWorksheet: () => void
}

const VisibleStatuses: WorksheetStatus[] = ['deAwaitingReceipt']

export const AcceptWorksheet: React.FC<Props> = ({
  worksheet,
  mutateWorksheet,
}) => {
  const { isChanged } = useWorksheetValueContext()
  const {
    account: { member: currentMember, selectedTrialHospitalRole },
  } = useAuthenticatedAccount()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useMirohaToast()

  const { request: acceptWorksheet } = useAcceptWorksheet({
    onSuccess: () => {
      mutateWorksheet()
      onClose()
      toast({
        status: 'success',
        title: 'ワークシートを受領しました',
      })
    },
    onError: error => {
      toast({
        status: 'error',
        title: error.message,
      })
    },
  })

  if (
    !canPerformWorksheetAction(
      'deAccept',
      currentMember.role,
      selectedTrialHospitalRole,
    )
  ) {
    return null
  }

  if (!VisibleStatuses.includes(worksheet.status)) {
    return null
  }

  return (
    <>
      <Button
        colorScheme="blue"
        isDisabled={isChanged || worksheet.status !== 'deAwaitingReceipt'}
        onClick={onOpen}
      >
        受領確定
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <Text fontSize="xl" fontWeight="bold">
              投薬指示の受領を確定しますか？
            </Text>
          </ModalHeader>
          <ModalBody>
            <Text>指示を受領します。</Text>
            <Text>受領確定後は編集できなくなりますのでご注意ください。</Text>
          </ModalBody>

          <ModalFooter>
            <ModalCancelButton />
            <Button
              colorScheme="blue"
              onClick={async () => {
                await acceptWorksheet({ worksheetUid: worksheet.uid })
              }}
            >
              確定する
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
